var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgVolumeOff15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25px",
  height: "21px",
  viewBox: "0 0 25 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "074A19D2-40E5-4069-B9F3-BE35E58C9334@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Schools/Web-SinglePlayer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schools/Lessons/SinglePlayer-active",
  transform: "translate(-752.000000, -703.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(753.000000, 704.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4438462,0.322332323 C13.4784914,-0.356320044 14.7890315,0.0715794127 15.3710194,1.27807251 C15.5519927,1.65324009 15.6470588,2.07643375 15.6470588,2.50688132 L15.6470588,16.4935632 C15.6470588,17.87783 14.6847261,19 13.4976285,19 C13.1284922,19 12.7655765,18.889144 12.4438462,18.6781122 L5.54308568,13.9651536 L2.21723427,13.9651536 C0.992689597,13.9651536 0,13.0755756 0,11.9782255 L0,7.01090528 C0,5.91355519 0.992689597,5.02397718 2.21723427,5.02397718 L5.54308568,5.02397718 L12.4438462,0.322332323 Z",
  id: "Path",
  stroke: "#72d7f2",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.676471, 9.829860) rotate(-315.000000) translate(-20.676471, -9.829860) translate(17.882353, 7.035742)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 2.79411765,
  y1: 0,
  x2: 2.79411765,
  y2: 5.58823529,
  id: "Line-5",
  stroke: "#72d7f2",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.79411765,
  y1: -2.10498285e-13,
  x2: 2.79411765,
  y2: 5.58823529,
  id: "Line-5",
  stroke: "#72d7f2",
  strokeWidth: 1.5,
  transform: "translate(2.794118, 2.794118) rotate(90.000000) translate(-2.794118, -2.794118) "
}))))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeOff15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/VolumeOff@1.5x.f128177da3ea463d3b759cd515adb7f9.svg";